import React from "react";

import { COPY } from "../i18n/storefrontCopy";
import { useStorefrontLocale } from "../i18n/StorefrontLocale";
import "./Footer.css";

// Shown on every page (agreed in the 2 Oct product meeting).
// English everywhere; on the storefront it follows the visitor's language.
const Footer = () => {
  const { lang, onPortfolioStorefront, onStorefront } = useStorefrontLocale();
  if (onStorefront || onPortfolioStorefront) return null;

  return (
    <footer className="footer" lang={onStorefront ? COPY[lang].htmlLang : undefined}>
      <p>{COPY[lang].communityFooter}</p>
    </footer>
  );
};

export default Footer;
